<template>
  <div class="game-login app-page-container">
    <headerBar :gameID="$store.state.gameID"></headerBar>
    <!-- <maskBar ></maskBar> -->

    <div class="game-login-body main-container">
      <div class="game-login-body-title">
        <span>Login</span>

        <span class="language" @click="showLanguage"><span class="icon"></span>
          {{ languageMap[lang] }}
          <span class="arrow"></span>
        </span>
      </div>
      <!-- <img
        src="../../src/assets/logo.png"
        :onerror="defaultImg"
        v-show="!$store.state.icon"
      />
      <img :src="$store.state.icon" v-show="$store.state.icon" /> -->

      <!-- <div class="game-login-desc set-margin">
        {{ $store.state.gameName }}<br />
      </div> -->
      <div class="game-login-desc"></div>
      <input class="mint-input" type="text" :placeholder="$t('common.playerId')" v-model.trim="formData.aid" />
      <input class="mint-input" type="text" :placeholder="$t('common.pin')" v-model.trim="formData.pin"
        @input="changePin" />
      <button class="game-button primary" :disabled="!formData.aid || !formData.pin" @click="logIn">
        {{ $t("common.submit") }}
      </button>
      <div class="game-inner">
        <div class="line"></div>
        <div class="text">FAQ</div>
        <div class="line"></div>
      </div>
      <div class="game-account" @click="handleCloseFaq(true)">
        <div class="text">
          {{ $t("loginFaq.desc") }}
        </div>
      </div>
      <div class="game-account" @click="handleCloseFaq(false)">
        <div class="text">{{ $t("loginFaq.del") }}</div>
      </div>
      <!-- <div class="footer-line"></div> -->
      <div class="game-footer">
        <img class="logo" src="../../src/assets/mgs_logo.png" />
        <div class="text">
          Mattel Game Studios HK Limited<br />
          © {{ getCurrentYear() }} Mattel. All rights reserved.
        </div>
      </div>
      <mt-popup v-model="loginFaq" class="loginfaq" position="bottom">
        <img class="close" @click="handleCloseFaq" src="../../src/assets/Union.png" />
        <div class="faq-title">
          {{ showStepOne ? $t("loginFaq.desc") : $t("loginFaq.del") }}
        </div>
        <div class="faq_content_box">
          <div class="faq_content">
            <div class="faq_step">
              Step1<img class="img" src="../../src/assets/ic_zs.png" />
            </div>
            <div v-html="$t('loginFaq.step1')" class="faq_desc"></div>
            <div class="faq_desc faq_pic">
              <img class="step-img" :src="faqImg" alt="" />
            </div>
            <div v-show="!showStepOne">
              <div class="faq_step">
                Step2<img class="img" src="../../src/assets/ic_zs.png" />
              </div>
              <div v-html="$t('loginFaq.step2')" class="faq_desc"></div>
              <div class="faq_step">
                Step3<img class="img" src="../../src/assets/ic_zs.png" />
              </div>
              <div v-html="$t('loginFaq.step3')" class="faq_desc"></div>
              <div class="faq_step">
                Step4<img class="img" src="../../src/assets/ic_zs.png" />
              </div>
              <div v-html="$t('loginFaq.step4')" class="faq_desc"></div>
            </div>
          </div>
        </div>
      </mt-popup>
    </div>
    <!-- <mt-actionsheet
      :actions="actions"
      :cancelText="$t('common.cancel')"
      v-model="sheetVisible"
    >
    </mt-actionsheet> -->
  </div>
</template>
<script>
import { Toast, Indicator } from "mint-ui";
import { getQueryString } from "../utils";
import getGameInfo from "../mixins/getGameInfo";
import headerBar from "../components/common/header_new";
import faqEn from "../assets/faq/en.png"
import faqDe from "../assets/faq/de.png"
import faqFr from "../assets/faq/fr.png"
import faqEs from "../assets/faq/es.png"
import faqJa from "../assets/faq/ja.png"

const faqImgMap = {
  en: faqEn,
  sp: faqEs,
  fr: faqFr,
  de: faqDe,
  jp: faqJa,
};
// Vue.component(Button.name, Button)
export default {
  components: {
    headerBar,
  },
  data() {
    return {
      test: navigator.userAgent,
      loginFaq: false,
      showStepOne: false,
      // sheetVisible: false,
      // actions: [],
      lang: localStorage.locale || "en",
      languageMap: {
        en: "English",
        sp: "Español",
        fr: "Français",
        de: "Deutsch",
        jp: "日本語",
      },
      formData: {
        // aid: "677433626207453607",
        // pin: "B0UOCC",
        gameID: 0,
        aid: "",
        pin: "",
        webAuthToken: "",
      },
      toPath: "Home",
    };
  },
  mixins: [getGameInfo],
  created() {
    const _this = this;

    _this.getQueryInfo();

    _this.toPath = getQueryString("f") || "Home";
  },
  unMounted() { },
  mounted() {
    const _this = this;

    _this.init();
    window.OmniSDKApi.on(function () {
      _this.autoLogin();
    });
    window.addEventListener(
      "pageshow",
      function () {
        window.OmniSDKApi.on(function () {
          _this.autoLogin();
        });
      },
      { passive: false }
    );
    window.addEventListener(
      "visibilitychange",
      function () {
        if (document.visibilityState === "visible") {
          window.OmniSDKApi.on(function () {
            _this.autoLogin();
          });
        }
      },
      {
        passive: false,
      }
    );
  },
  computed: {
    defaultImg() {
      return '_this.src="' + require("../../src/assets/logo.png") + '"';
    },
    faqImg() {
      return faqImgMap[localStorage.getItem("locale") || "en"];
    },
  },
  methods: {
    // 生成sid 规则 CRC16(ua) % 10
    calculateCRC16() {
      let crc = 0xffff;
      const str = navigator.userAgent;
      for (let i = 0; i < str.length; i++) {
        crc ^= str.charCodeAt(i) << 8;
        for (let j = 0; j < 8; j++) {
          if (crc & 0x8000) {
            crc = (crc << 1) ^ 0x8005;
          } else {
            crc <<= 1;
          }
        }
      }
      return (crc & 0xffff) % 20;
    },
    handleCloseFaq(val) {
      const _this = this

      val ? (_this.showStepOne = true) : (_this.showStepOne = false);
      _this.loginFaq = !_this.loginFaq;
    },
    // showLanguage() {
    //   _this.$message({
    //     type: "success",
    //     text: "",
    //   });
    // },
    getQueryInfo() {
      const _this = this

      _this.$store.state.gameID = getQueryString("gameID");
      _this.$store.state.aid = getQueryString("aid");
      // 获取图标等信息
      if (_this.$store.state.gameID) {
        _this.getGameList();
      }
    },
    // setScreenLock(){
    //      if(location.href.indexOf("landscape=true") > -1){
    //           localStorage.screenLock = 'landscape'
    //     }else  if (  location.href.indexOf("portrait=true") > -1){
    //       localStorage.screenLock = 'portrait'
    //     }else{
    //       localStorage.screenLock = ''
    //     }
    // },
    init() {
      const _this = this

      history.pushState(null, null, document.URL);
      window.addEventListener("popstate", function () {
        history.pushState(null, null, document.URL);
      });

      _this.formData.gameID = _this.$store.state.gameID
        ? _this.$store.state.gameID * 1
        : _this.formData.gameID * 1;

      if (_this.$store.state.aid) {
        //路由里存在
        _this.formData.aid = _this.$store.state.aid;
      }
    },
    changePin() {
      const _this = this

      _this.formData.pin = _this.formData.pin.toUpperCase();
    },
    autoLogin() {
      const _this = this

      function doLogin() {
        window.OmniSDKApi.getWebAuth(function (err, dt) {
          if (err) {
            Indicator.close();
          } else {
            // 执行 webAuthToken 登录
            _this.formData.webAuthToken =
              dt.data.webAuthToken || dt.webAuthToken;

            _this.$axios({
              method: "post",
              url: "/privacy/webToken/login",
              data: { ..._this.formData, ua: navigator.userAgent || "" },
            })
              .then((res) => {
                if (res.status === 200 && res.data.c === 0) {
                  // 登录验证成功
                  const result = res.data.r;
                  _this.$store.state.gameID = result.gameID;
                  _this.$store.state.gameName = result.name;
                  _this.$store.state.icon = result.icon;
                  _this.$store.state.serviceMail =
                    result.serviceMail || "mgs-cs@mattel.com";
                  _this.$store.state.aid = _this.formData.aid;
                  _this.$store.state.pin = _this.formData.pin;
                  _this.$store.state.taskExist = res.data.r.taskExist; //是否已经创建过删除任务
                  _this.$store.state.canCancel = res.data.r.canCancel; //是否可以取消
                  _this.$store.state.doNotSell = res.data.r.doNotSell;
                  _this.$store.state.autoLogined = true;
                  _this.$cookie.set("token", res.data.r.pinToken); //存储token
                  if (res.data.r.isWhite) {
                    localStorage.setItem("privacy_sid", -1);
                  } else {
                    const sid = _this.calculateCRC16();
                    localStorage.setItem("privacy_sid", sid);
                  }
                  _this.$router.push({
                    name: _this.toPath,
                  });
                } else {
                  Toast({
                    message: _this.$t("toast.error"),
                  });
                }

                Indicator.close();
              })
              .catch((e) => {
                console.error(e);
                Indicator.close();
                Toast({
                  message: _this.$t("toast.error"),
                });
              });
          }
        }, "appAuth");
      }
      Indicator.open();
      if (!_this.$store.state.aid) {
        const userP = new Promise((resolve) => {
          window.OmniSDKApi.getUserInfo(function (err, outData) {
            if (err) {
              Indicator.close();
            }
            resolve(outData);
          });
        });
        const arr = [userP];
        let ios = false;
        if (/(iPhone|iPad|iPod|iOS|Macintosh)/i.test(navigator.userAgent)) {
          ios = true;

          const comP = new Promise((resolve) => {
            window.OmniSDKApi.getCommonInfo(function (err, outData) {
              if (err) {
                Indicator.close();
              }
              resolve(outData);
            });
          });
          arr.push(comP);
        }
        Promise.all(arr).then((res) => {
          _this.formData.aid = res[0]?.aid ?? "";
          _this.$store.state.gameID = res[0]?.gameId;
          _this.formData.gameID = res[0]?.gameId;

          if (ios) {
            _this.$store.state.gameID = res[1]?.gameID;
            _this.formData.gameID = res[1]?.gameID;
          }

          return doLogin();
        });
      } else {
        return doLogin();
      }
    },
    changeLang({ value }) {
      const _this = this

      localStorage.setItem("locale", value);
      _this.lang = value;
      _this.sheetVisible = false;
      setTimeout(() => {
        location.reload();
      }, 500);
    },
    showLanguage() {
      const _this = this

      _this.$emit('showLanguage')
    },

    logIn() {
      const _this = this

      _this.$axios({
        method: "post",
        url: "/privacy/pin/login",
        data: { ..._this.formData, ua: navigator.userAgent || "" },
      })
        .then((res) => {
          if (res.status === 200) {
            if (res.data.c === 0) {
              // 登录验证成功
              const result = res.data.r;
              _this.$store.state.gameID = result.gameID;
              _this.$store.state.gameName = result.name;
              _this.$store.state.icon = result.icon;
              _this.$store.state.serviceMail =
                result.serviceMail || "mgs-cs@mattel.com";
              _this.$store.state.aid = _this.formData.aid;
              _this.$store.state.pin = _this.formData.pin;
              _this.$store.state.taskExist = res.data.r.taskExist; //是否已经创建过删除任务
              _this.$store.state.canCancel = res.data.r.canCancel; //是否可以取消
              _this.$store.state.doNotSell = res.data.r.doNotSell;
              _this.$cookie.set("token", res.data.r.pinToken); //存储token
              if (res.data.r.isWhite) {
                localStorage.setItem("privacy_sid", -1);
              } else {
                const sid = _this.calculateCRC16();
                localStorage.setItem("privacy_sid", sid);
              }
              _this.$router.push({
                name: _this.toPath,
              });
            } else {
              Toast({
                message:
                  res.data.d.indexOf("account") > -1
                    ? _this.$t("toast.countWrong")
                    : res.data.d,
              });
            }
          } else {
            Toast({
              message:
                res.data.d.indexOf("account") > -1
                  ? _this.$t("toast.countWrong")
                  : res.data.d,
            });
          }
        })
        .catch(() => {
          Toast({
            message: _this.$t("toast.error"),
          });
        });
    },
  },
};
</script>
<style lang="less" scoped>
// @media screen and (min-width: 600px) {
//   .language {
//     text-align: center;
//   }
//   .loginfaq {
//     width: 40%;
//   }
// }
@media screen and (max-width: 599px) {
  .language {
    margin-left: 20px;
    text-align: left;
  }

  .loginfaq {
    width: 100%;
    height: 80%;
  }

}


.mint-input {
  min-height: 40px;
  margin-bottom: 0.42rem;
}

.game-button {
  min-height: 40px;
  font-size: 0.42rem;
}

.game-login {
  width: 100%;
  height: 100%;
  // background: #f3f3f3;
  // display: flex;
  // align-items: center;
  // flex-direction: column;
  min-height: 100%;

  .footer-line {
    height: 1px;
    width: 100%;
    margin-top: 30px;
    background-color: #cfd5e0;
  }

  .game-inner {
    width: 100%;
    margin-top: 0.5rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    .line {
      height: 1px;
      width: 3rem;
      background-color: #cfd5e0;
    }

    .text {
      color: #1a2333;
      font-family: Arial;
      font-size: 0.42rem;
      font-style: normal;
      font-weight: 800;
      line-height: 0.36rem;
      /* 125% */
    }
  }

  .game-account {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    min-height: 40px;
    height: 1.06rem;
    margin-top: 0.42rem;
    background: #f5f5f5;
    border: 0.5px #c8c8c8 solid;

    .text {
      color: #000000;
      padding: 10px;
      font-family: Arial;
      font-size: 0.35rem;
      font-style: normal;
      font-weight: 800;
      line-height: 20px;
      text-align: center;
    }
  }

  .loginfaq {
    height: 100%;
    width: 100%;
    background: #fff;
    display: flex;
    flex-direction: column;
    overflow-y: hidden;
    padding-bottom: 0.84rem;
    box-sizing: border-box;
    padding-top: 0.64rem;

    .close {
      width: 12px;
      margin: 0.53rem 0 0 0.53rem;
      margin-bottom: 10px;
      position: absolute;
      top: 0;
      left: 0;
    }

    .faq-title {
      text-align: center;
      font-size: 0.53rem;
      font-weight: 600;
      line-height: 24px;
      color: #000;
      width: 80%;
      margin: 0 auto;
    }

    .faq_content_box {
      width: 100%;
      min-height: 85%;
      overflow-y: auto;
    }

    .faq_content {
      width: 90%;
      // height: 100%;
      margin: 5%;
      border-radius: 13px;
      background: #f6f6f6;
      // min-height: 85%;
      // overflow-y: auto;
      flex-direction: column;

      .faq_step {
        position: relative;
        color: #000;
        margin: 0.42rem;
        font-size: 0.42rem;
        font-weight: 600;
        line-height: 0.64rem;
        letter-spacing: -0.4px;

        .img {
          position: absolute;
          bottom: -0.01rem;
          left: 0;
          width: 1.3rem;
        }
      }

      .faq_desc {
        color: #575c66;
        margin: 15px;
        text-align: left;
        font-size: 0.38rem;
        font-weight: 500;
        line-height: 0.56rem;

        .step-img {
          width: 97%;
        }
      }

      .faq_pic {
        text-align: center;
      }
    }
  }

  .language {
    font-size: 0.37rem;
    display: inline-block;
    width: auto;
    height: 0.56rem;
    background: #f5f5f5;
    padding: 0.13rem 0.3rem;
    color: #333333;
    border-radius: 0.4rem;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: normal;

    .icon {
      background: url("../assets/ic_i18n.png") no-repeat center center;
      background-size: contain;
      width: 0.55rem;
      height: 0.55rem;
      display: inline-block;
      margin-right: 0.1rem;
    }

    .arrow {
      background: url("../assets/arrow.png") no-repeat center center;
      background-size: contain;
      width: 0.26rem;
      height: 0.26rem;
      display: inline-block;
      margin-left: 0.1rem;
    }
  }

  &-body {

    // width: 100%;
    // height: 100%;
    // border-radius: 0.4rem 0.4rem 0 0;
    // margin-top: -0.4rem;
    // background: #fff;
    // padding:  0.64rem;
    // box-sizing: border-box;
    // flex: 1;
    &-title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 0.48rem;
      font-weight: 800;
    }
  }

  &-desc {
    margin-bottom: 0.5rem;
    color: #262626;
    font-family: Arial Black;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    /* 111.111% */
    font-size: 0.72rem;
    text-align: center;
  }

  &-desc2 {
    margin-bottom: 0.32rem;
    padding: 0 0.32em 0 0.32em;
    text-align: center;
    color: #aaa;
    font-size: 0.32rem;

    .more {
      text-align: center;
    }

    a {
      text-decoration: none;
    }
  }
}

@media screen and (orientation: portrait) {

  // 竖屏样式
  .game-footer {
    background: #ffffff;

    width: 100%;
    height: 2.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    bottom: 0;
    box-sizing: border-box;
    margin: 0 auto;
    left: 50%;
    transform: translateX(-50%);

    .logo {
      width: 1.4rem;
      margin-right: 10px;
    }

    .text {
      color: #666;
      text-align: left;
      font-family: Arial;
      font-size: 10px;
      font-style: normal;
      font-weight: 400;
      line-height: 0.42rem;
      // min-width: 70%;
    }
  }
}

.main-container {
  overflow-y: auto;
}

@media screen and (orientation: landscape) {
  // 横屏样式

  .main-container {
    padding-bottom: 0.64rem !important;
  }

  .game-footer {
    background: #ffffff;

    width: 100%;
    height: 2.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    // margin: 0 auto;
    left: 50%;

    // transform: translateX(-50%);
    .logo {
      width: 1.4rem;
      margin-right: 10px;
    }

    .text {
      color: #666;
      text-align: left;
      font-family: Arial;
      font-size: 10px;
      font-style: normal;
      font-weight: 400;
      line-height: 16px;
      // min-width: 70%;
    }
  }

  .loginfaq {
    width: 100%;
    height: 80%;
  }

  .game-login .loginfaq .faq_content {
    width: 60% !important;
    margin: 0 auto;

    .faq_desc.faq_pic {
      width: 60%;
      margin: 0 auto;
    }
  }
}
</style>
